import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { GoogleAnalyticsService, MakingWavesLoaderService } from './modules/shared/services';
import { filter, interval, Subscription } from 'rxjs';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Event as RouterEvent } from '@angular/router';
import { getCurrentUser } from '@aws-amplify/auth';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { AppToolbarComponent } from './modules/shared/components/app-toolbar/app-toolbar.component';
import { AppMenuComponent } from './modules/shared/components/app-menu/app-menu.component';
import { MakingWavesLoaderComponent } from './modules/shared/components/making-waves-loader/making-waves-loader.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterOutlet, AppToolbarComponent, AppMenuComponent, MakingWavesLoaderComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  public showVersionUpdateBanner = false;
  private subService: Subscription | undefined;
  private hubListenerCancelToken: any;

  public loaderService = inject(MakingWavesLoaderService);
  private router = inject(Router);
  private analyticsService = inject(GoogleAnalyticsService);
  private swUpdate = inject(SwUpdate);

  isLoginRoute(): boolean {
    return this.router.url.startsWith('/login');
  }

  isFullscreenRoute(): boolean {
    return this.router.url.includes('/app-novnc-gallery');
  }

  ngOnInit(): void {
    this.checkForVersionUpdates();

    // For google Analytics    
    console.log('[App] ngOnInit starting');
    this.analyticsService.initialize();
    console.log('[App] after analytics.initialize()');

    this.router.events
      .pipe(
        filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
         this.analyticsService.sendEvent('page_view', { page_path: event.urlAfterRedirects });
      });

    this.setAnalyticsUser()      
  }

  async setAnalyticsUser() {
      try {
        const { username, userId } = await getCurrentUser();
        this.analyticsService.setUserId(username);
      } catch (err) {
        // User is not authenticated — redirect to login
        if (!this.isLoginRoute()) {
          alert('פג תוקף ההתחברות, יש להתחבר מחדש');
          this.router.navigate(['/login']);
        }
      }
  }

  private checkForVersionUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      console.log('[SW] SwUpdate is not enabled');
      return;
    }

    console.log('[SW] SwUpdate is enabled, subscribing to version updates');

    this.swUpdate.versionUpdates.subscribe((event) => {
      console.log('[SW] Version event:', event.type, event);
    });

    this.swUpdate.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        console.log('[SW] New version ready — showing banner');
        this.showVersionUpdateBanner = true;
      });

    // Check immediately on load, then poll every 1 minute
    this.swUpdate.checkForUpdate().then((hasUpdate) => {
      console.log('[SW] Initial check — update available:', hasUpdate);
    });
    interval(60_000).subscribe(() => this.swUpdate.checkForUpdate());
  }

  // Called from the version-update banner button. The new version was already
  // downloaded by the service worker in the background. Reloading the page causes
  // the browser to request index.html again, which the SW now serves from its
  // updated cache — so the user gets the new JS/CSS bundles.
  applyUpdate(): void {
    document.location.reload();
  }

  ngOnDestroy(): void {
    if (this.subService)
      this.subService.unsubscribe();
    if (this.hubListenerCancelToken)
      this.hubListenerCancelToken();

  }


}

